import { FeatureContainer } from '../../../../molecules/Containers/FeatureContainer';
import { Modal } from '../../../../organisms/Modals/Modal';
import { ButtonWithText } from '../../../../atoms/Buttons/ButtonWithText';
import React from 'react';
import useStyle from './rgpd.style';

interface RgpdProps {
  next: () => void;
}
export const Rgpd = ({ next }: RgpdProps) => {
  const classes = useStyle();
  return (
    <>
      <div className={classes.headintro}>
        <p>Bonjour et bienvenue sur France Challenges.</p>
      </div>
      <FeatureContainer>
        <p>
          Avant de pouvoir continuer sur France Challenges, on a besoin de
          quelques informations te concernant.
          <br />
          Il te suffit de remplir les champs demandés (les{' '}
          <span role="img" aria-label="croix">
            ❌
          </span>{' '}
          doivent devenir des{' '}
          <span role="img" aria-label="check">
            ✅
          </span>
          ).
        </p>
      </FeatureContainer>
      <div className={classes.actionboxintro}>
        <p>Par exemple, appuie sur ce bouton</p>
        <Modal
          modalHead="Protection des données"
          triggerButton={
            <div className={classes.dashblock}>
              <ButtonWithText
                onClick={() => console.log(' ')}
                content="Continuer"
              />
            </div>
          }
          actionButton={
            <ButtonWithText onClick={next} content="J'ai compris !" />
          }
        >
          <div className={classes.modalContent}>
            <p>
              Nous allons enregistrer tes données personnelles. Les finalités de
              la collecte de ces données sont de te permettre :
            </p>
            <ul className={classes.modalList}>
              <li>
                D'accéder à l’application grâce à une clé d’identification
                unique (l’adresse mail)
              </li>
              <li>
                D'utiliser les ressources numériques et pédagogiques mises à
                disposition
              </li>
              <li>
                D'être rappelé par France Challenges pour répondre à tes
                éventuelles questions (mobile)
              </li>
              <li>
                De répondre à une enquête de satisfaction en fin de challenge
              </li>
              <li>
                D'obtenir les supports de communication et informations au sujet
                des concours pédagogiques organisés sur les réseaux sociaux de
                l’Entreprise
              </li>
            </ul>

            <p>
              Aucune commercialisation et communication commerciale de ces
              données ne sera réalisée.
            </p>
            <p>
              Tu bénéficies en outre d’un droit d’accès, de rectification,
              d’effacement, de portabilité et de limitation et opposition du
              traitement des données te concernant que tu pourras exercer en
              envoyant un email à l’adresse suivante:{'\u00A0'}
              <span className={classes.textContrast}>
                dpo@france-challenges.com
              </span>
              .
            </p>
            <p>
              Pour plus d’informations sur le traitement de tes données
              personnelles par « France Challenges » tu peux consulter la
              {'\u00A0'}
              <a
                href="https://drive.google.com/file/d/1hIKftLx9_wpVVVHnfDyiMpl3iZpuFL5Y/view?usp=share_link"
                className={classes.textContrast}
              >
                politique de confidentialité
              </a>{' '}
              accessible sur le site:
              {'\u00A0'}
              <a
                href="www.france-challenges.com"
                className={classes.textContrast}
              >
                www.france-challenges.com
              </a>
              .
            </p>
            <p>
              Enfin, si tu n'acceptes pas de nous communiquer une adresse mail
              (que tu peux cependant créer uniquement pour ce challenge) et un
              numéro de téléphone, nous te proposons d'alerter ton professeur
              immédiatement afin de trouver une solution. Car nous ne pourrons
              pas t'ouvrir l'application.
            </p>
          </div>
        </Modal>
      </div>
    </>
  );
};
